import { Component, input } from '@angular/core';

import type { AggregatedEvaluationsSkillProficiencyRating } from '@core/evaluations-types';
import {
  AvatarComponent,
  BoxComponent,
  DividerComponent,
  RtTooltip,
} from '@core/user-interface-legacy';

import { EvaluationSkillScaleRatingComponent } from '../evaluation-skill-scale-rating/evaluation-skill-scale-rating.component';

@Component({
  selector: 'rt-evaluation-skill-ratings',
  templateUrl: './evaluation-skill-ratings.component.html',
  styleUrl: './evaluation-skill-ratings.component.less',
  imports: [
    AvatarComponent,
    BoxComponent,
    DividerComponent,
    EvaluationSkillScaleRatingComponent,
    RtTooltip,
  ],
})
export class EvaluationSkillRatingsComponent {
  public ratings = input.required<AggregatedEvaluationsSkillProficiencyRating[]>();
}
